export default {
    data() {
        return {
            nameSearch: '',
            orderNumSearch: '',
            // 总条数
            total: 0,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            // 订单数据
            orders: []
        }
    },
    methods: {

        // 获取订单数据
        getOrdersData() {
            //pay_type 1 支付宝 2微信
            //state 0 未付款 2已付款 5已失效
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
                this.orders = res.data.result.data
                this.total = res.data.result.total
                return res.data.result.data;
            });
        },

        // 搜索
        search() {
            //pay_type 1 支付宝 2微信
            //state 0 未付款 2已付款 5已失效
            this.$post("orders/shop_search", {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.pageSize,
                pay_type: this.pay_type_value,
                state: this.order_type_value,
                user_name: this.nameSearch,
                code: this.orderNumSearch
            }).then(res => {
				this.currentPage = 1
                this.orders = res.data.result.data
                this.total = res.data.result.total
                return res.data.result.data;
            });
        },

        // 点击取消订单
        cancelOrder (order) {
            this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handleCancelOrder(order)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },

        // 取消订单
        handleCancelOrder (order) {
            this.$post('orders/cancel', {
                id: order.id,
                token: this.$store.state.authority_management,
                state: '5'
            }).then(res => {
                if (res.status === 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                }
                this.getOrdersData()
            })
        },

        // 删除该订单的订单项
        deletePurchased(order) {
            this.$post()
        },

        // 当前页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.getOrdersData()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.getOrdersData()
        }
    },
    mounted() {
        // 获取订单数据
        this.getOrdersData()
    },
}